import { Button, Spinner, SwitchOnChangeData } from "@fluentui/react-components";
import DownloadIcon from "~icons/material-symbols/download";

import { ChangeEvent, memo, useCallback } from "react";
import { EllipsisTooltip } from "../../../components/EllipsisTooltip/EllipsisTooltip";
import { Redline } from "../../../components/Redline";
import { useAppData } from "../../../hooks";
import { useSuggestionToolbarStyles } from "../styles/SuggestionToolbar.styles";
import { SuggestionFilterForm } from "./SuggestionFilterForm";
import { SuggestionFootnoteMenu } from "./SuggestionFootnoteMenu";
import { SuggestionRankingForm } from "./SuggestionRankingForm";

type SuggestionToolbarProps = {
  appId: string;
  onExport?: () => void;
};

export const SuggestionToolbar = memo(function SuggestionToolbar({ appId, onExport }: SuggestionToolbarProps) {
  const styles = useSuggestionToolbarStyles();
  const [redlined, setRedlined] = useAppData<boolean>(appId, "redlined");
  const [isExporting] = useAppData<boolean>(appId, "isExporting", false);

  const ontoggleRedlining = useCallback(
    (_ev: ChangeEvent, data: SwitchOnChangeData) => {
      setRedlined(data.checked as boolean);
    },
    [setRedlined]
  );

  return (
    <div className={styles.toolbar}>
      <div className={styles.toolbarToggleContainer}>
        <Redline redlined={redlined} ontoggleRedlining={ontoggleRedlining} styles={styles} />
      </div>

      <div className="flex items-center">
        <Button
          appearance="transparent"
          onClick={onExport}
          disabled={isExporting}
          icon={
            isExporting ? (
              <Spinner size="tiny" />
            ) : (
              <EllipsisTooltip content="Export Results" positioning={{ align: "center", offset: 4 }}>
                <DownloadIcon />
              </EllipsisTooltip>
            )
          }
        />
        <SuggestionFootnoteMenu appId={appId} />
        <SuggestionRankingForm appId={appId} />
        <SuggestionFilterForm appId={appId} />
      </div>
    </div>
  );
});
